import React from 'react';
import VoiceInteractionPicker from '@/components/SAM/VoiceInteractionPicker';
import { BackIcon } from '@/components/Onboarding/StepShell';
import { Button } from '@/components/UI/Button';

interface VoiceModeStepProps {
  mode: 'text' | 'voice';
  voiceGender: 'male' | 'female' | null;
  onModeChange: (m: 'text' | 'voice') => void;
  onVoiceGenderChange: (g: 'male' | 'female') => void;
  onBack: () => void;
  onFinish: () => void;
  finishing?: boolean;
  disabled?: boolean;
}

/**
 * User-onboarding step 2 — choose interaction mode (Text Only / Voice). In Voice mode the user
 * picks one of the configured voices; each card plays a sample clip (sample_url from config).
 */
const VoiceModeStep: React.FC<VoiceModeStepProps> = ({
  mode,
  voiceGender,
  onModeChange,
  onVoiceGenderChange,
  onBack,
  onFinish,
  finishing = false,
  disabled = false,
}) => {
  return (
    <div className={`card-surface p-6 sm:p-8 ${disabled ? 'pointer-events-none opacity-60 select-none' : ''}`}>
      <h2 className="text-h3 text-ui-text mb-1">Voice &amp; interaction</h2>
      <p className="text-ui-text2 text-sm mb-6">Choose how you'd like to interact with SAM.</p>

      <VoiceInteractionPicker
        mode={mode}
        voiceGender={voiceGender}
        onModeChange={onModeChange}
        onVoiceGenderChange={onVoiceGenderChange}
      />

      <div className="flex gap-3 mt-6">
        <Button type="button"
          onClick={onBack}
          variant="outline" size="lg" className="flex-1">
          <BackIcon />
          Back
        </Button>
        <Button type="button"
          onClick={onFinish}
          disabled={finishing || (mode === 'voice' && !voiceGender)}
          size="lg" className="flex-1">
          {finishing ? 'Finishing…' : 'Finish Setup'}
          <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
        </Button>
      </div>
    </div>
  );
};

export default VoiceModeStep;
